import { render, staticRenderFns } from "./SysDeptList.vue?vue&type=template&id=7dd81ebb&scoped=true"
import script from "./SysDeptList.vue?vue&type=script&lang=js"
export * from "./SysDeptList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd81ebb",
  null
  
)

export default component.exports